import {inMillion} from '@pb/kit-util-in-million';

import type {Locale} from '@pb/kit-context-locale';

/**
 * @description Format money value based on its currency
 * @param {number|null|undefined} value - input value
 * @param {Locale} locale - user's locale
 * @return {number} - formatted money amount
 * @example
 * //returns 1000
 * toFinancials(1000000, {currency: 'USD'});
 * //returns 1
 * toFinancials(1000000, {currency: 'JPY'});
 */
export const toFinancials = (
    value: number | null | undefined,
    {currency}: Locale,
): number | null | undefined => {
    if (typeof value !== 'number') {
        return null;
    }

    const divisor = inMillion(currency) ? 1e6 : 1e3;
    return value / divisor;
};
